import { createStore } from '../store';

export const store = createStore();
